import { render, staticRenderFns } from "./DealListRow.vue?vue&type=template&id=4a316b78&"
import script from "./DealListRow.vue?vue&type=script&lang=js&"
export * from "./DealListRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports